export default __webpack_public_path__ + "static/media/spacefit4.9f043763.jpg";